//the initialize
angular.module('contactEmployerModule', ['ui.bootstrap', 'cacheManagerModule'])
    .directive('phoneFormatter', ['$filter', '$browser', phoneFormatter])
    .filter('phoneFilter', [phoneFilter])
    .directive('textFormatter', [textFormatter])
    .directive('cityFormatter', [cityFormatter])
    .service('confirmationService', [confirmationService])
    .controller('confirmationModalController', ['$scope', '$modalInstance', 'confirmationService', confirmationModalController])
    .service('contactEmployerService', ['$q', 'cacheManagerService', contactEmployerService])
    .controller('contactEmployerController', ['$q', '$scope', 'contactEmployerService', '$modal', contactEmployerController]);